import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  clientOvertime: undefined,
};

export const overtimeSlice = createSlice({
  name: "overtimeSlice",
  initialState,
  reducers: {
    setClientOvertime(state: any, action: PayloadAction<any>) {
      return {
        ...state,
        clientOvertime: action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setClientOvertime } = overtimeSlice.actions;

export default overtimeSlice.reducer;
